import { bindSiteEvents } from '@ff-os/pdp-shared-redux/global-state/site-events';
import { bindSitePricing } from '@ff-os/pdp-shared-redux/global-state/site-pricing';
import { IDT } from '@ff-os/pdp-shared-redux/IDT';
import { DisplayMode } from '@ff-os/pdp-shared-redux/slices/globalSlice';
import { PdpStore } from '@ff-os/pdp-shared-redux/store';
import { scenePlugins } from '@ff-os/pdp-shared-registry/index';
import { registerAddUserImagesFromUrls } from './addUserImagesFromUrls';

export const registerSiteInteractions = (
    store: PdpStore,
    options: IDT.Options | IDT.HydrateOptions,
    displayMode: DisplayMode
) => {
    bindSiteEvents(options.events);
    bindSitePricing(options.pricing);
    registerShow(store, options.containers, displayMode);
    registerClose(store);
    registerAddUserImagesFromUrls(store);
};

const registerShow = (store: PdpStore, containers: IDT.Containers, displayMode: DisplayMode) => {
    window.__idt_show = (prefabId?: string) => {

        if (prefabId && typeof window !== 'undefined') {
            const state = store.getState();
            const scenePlugin = scenePlugins.require(state.scene.pluginId) as any;

            if (typeof scenePlugin.applyPrefab === 'function') {
                scenePlugin.applyPrefab(store.dispatch, store.getState, prefabId);
            }
        }

        scenePlugins
            .require(store.getState().scene.pluginId)
            .show(store.dispatch, containers, displayMode);
    };
};

const registerClose = (store: PdpStore) => {
    window.__idt_close = () => {
        scenePlugins
            .require(store.getState().scene.pluginId)
            .close(store.dispatch);
    };
};